import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { backButton } from '@telegram-apps/sdk-react';

import { Cell } from '@/components/common/Cell/Cell.tsx';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { useUnmatchAction } from '@/hooks/useUnmatchAction.tsx';
import { SystemModalContainer } from '@/components/common/SystemModal/SystemModal.tsx';
import { routes } from '@/navigation/routes.tsx';

export const MenuModal: FC<{
  id: string;
  name: string;
  closeMenu: () => void;
  openReport: () => void;
}> = ({ id, name, closeMenu, openReport }) => {
  const { t } = useTranslation();
  const { removeDialog } = useDialogsStore();

  const navigate = useNavigate();

  const handleUnmatch = async () => {
    await removeDialog({ hid: id, shouldCallApi: true });

    backButton.hide();
    navigate(routes.messenger);
  };

  const openUnmatchPopup = useUnmatchAction(id, name, handleUnmatch);

  const handleOpenUnmatchPopup = () => {
    void openUnmatchPopup();
  };

  const openReportModal = () => {
    openReport();
    closeMenu();
  };

  return (
    <SystemModalContainer
      headerTitle={t('chats.options')}
      handleClose={closeMenu}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}
      >
        <div onClick={handleOpenUnmatchPopup}>
          <Cell> {t('unmatch_action')} </Cell>
        </div>
        <div
          style={{ color: '#f70505', marginTop: 10 }}
          onClick={openReportModal}
        >
          <Cell> {t('report_action')} </Cell>
        </div>
      </div>
    </SystemModalContainer>
  );
};
